<template>
  <el-dialog title="考勤打卡日统计明细" :visible.sync="visible" width="80%" :close-on-click-modal="false">
    <div class="filters-clock">
      <div class="filters-clock-right" style="margin-right: 10%">打卡人数：{{dayWorkNums}} 人</div>
      <div class="filters-clock-right">缺卡人数：{{dayLoseCardNums}} 人</div>
    </div>
    <el-form :inline="true" ref="form" :model="form" class="demo-form-inline" size="small">
      <el-form-item label="姓名">
        <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
      </el-form-item>
      <el-form-item label="考勤类型">
        <el-select v-model="form.clockType" placeholder="请选择考勤类型">
          <el-option
            v-for="item in clockTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
        <el-button @click="onReset">重置</el-button>
      </el-form-item>
    </el-form>
    <div>
      <w-table height="400px"
               v-loading.body="clockTableLoading"
               :data-list="clockTableData"
               :columns="columns"
               :pageNo="clockFormData.pageNum"
               :pageSize="clockFormData.pageSize"
               :total="clockTotal"
               :bPagination="true"
               :needSelection="false"
               @pageNoChange="clockPageNoChange"
               @pageSizeChange="clockPageSizeChange">
        <template v-slot:cell="props">
            <span v-if="props.column.label === '序号'">
              {{ props.index + 1 + (clockFormData.pageNum - 1) * clockFormData.pageSize }}
            </span>
          <div v-else-if="props.column.label === '用户名'">
            {{props.row.name}}
          </div>
          <div v-else-if="props.column.label === '角色类型'">
            {{props.row["clockRole"] | filterClockRole}}
          </div>
          <span v-else-if="props.column.label === '品牌名称'" v-show="props.row['clockRole']== 1">
            {{props.row["brandId"] | filterBrandName(brands)}}
          </span>
          <div v-else-if="props.column.label === '平均工时'">
            {{props.row.sumWorkHours}}
          </div>
          <div v-else-if="props.column.label === '上班打卡时间'">
            <div class="table-line">
              {{props.row.startTime}}
            </div>
          </div>
          <div v-else-if="props.column.label === '上班打卡地点'">
            {{props.row.startSite}}
          </div>
          <div v-else-if="props.column.label === '下班打卡时间'">
            <div class="table-line">
              {{props.row.endTime}}
            </div>
          </div>
          <div v-else-if="props.column.label === '下班打卡地点'">
            {{props.row.endSite}}
          </div>
          <div v-else-if="props.column.label === '创建时间'">
            <div class="table-line">
              {{props.row.createTime | dateFormat('yyyy-MM-dd hh:mm:ss')}}
            </div>
          </div>
          <span v-else>{{ props.row[props.column.property]}}</span>
        </template>
      </w-table>
    </div>
  </el-dialog>
</template>

<script>
import WTable from '@/components/Table/index.vue'
import staticData from '@/views/DailyDuty/staticData.js'
import { mapGetters } from 'vuex'
import Api from '@/api'
export default {
  components: { WTable },
  computed: {
    ...mapGetters([
      'brands',
      'selfAreaId'
    ]),
    staticData() {
      return staticData
    }
  },
  data() {
    return {
      visible: false, // 控制弹框显示与否
      form: {},
      clockTypeOptions: [
        {
          value: '',
          label: '全部'
        }, {
          value: 1,
          label: '已打卡'
        }, {
          value: 2,
          label: '缺卡'
        }
      ],
      clockTableLoading: false,
      clockTableData: [],
      clockFormData: {
        pageNum: 1,
        pageSize: 20
      },
      clockPageSizes: [10, 20, 50],
      clockTotal: 0,
      showBrandColumn: true,
      columns: [{
        prop: 'index',
        label: '序号',
        width: '50'
      }, {
        prop: 'name',
        label: '用户名',
        width: '100'
      }, {
        prop: 'roleType',
        label: '角色类型',
        width: '100'
      }, {
        prop: 'brandName',
        label: '品牌名称',
        width: '100'
      }, {
        prop: 'startTime',
        label: '上班打卡时间',
        width: '120'
      }, {
        prop: 'startSite',
        label: '上班打卡地点',
        width: '200'
      }, {
        prop: 'endTime',
        label: '下班打卡时间',
        width: '120'
      }, {
        prop: 'endSite',
        label: '下班打卡地点',
        width: '200'
      }, {
        prop: 'createTime',
        label: '创建时间',
        width: '120'
      }],
      dayWorkNums: 0, // 打卡人数
      dayLoseCardNums: 0, // 缺卡人数
      clockRow: {} // 日统计总数点击对应的行
    }
  },
  filters: {
    filterBrandName(value, brands) {
      return brands.some(item => String(item.brandId) === String(value))
        ? brands.find(item => String(item.brandId) === String(value)).brandName
        : undefined
    },
    filterClockRole(value) {
      return {
        1: '运维员',
        2: '监管员'
      }[Number(value)]
    }
  },
  methods: {
    // 自定义方法来打开弹框
    clockDayDialog(row) {
      this.clockRow = row
      this.clockTableLoading = true
      const params = {
        selfAreaId: this.selfAreaId,
        currentPage: this.clockFormData.pageNum,
        pageSize: this.clockFormData.pageSize,
        brandId: row.brandId,
        dateFormat: row.dateFormat,
        clockRole: row.clockRole
      }
      Api.getClockStatisticsDayList(params)
        .then(res => {
          this.clockTableData = res.data.pageInfo.list
          this.clockTotal = res.data.pageInfo.total
          this.dayWorkNums = res.data.workDays
          this.dayLoseCardNums = res.data.loseCardNums
          this.dynamicColumns(row.clockRole)
          this.visible = true
          this.clockTableLoading = false
        })
    },
    initData() {
      const row = this.clockRow
      this.clockTableLoading = true
      const params = {
        selfAreaId: this.selfAreaId,
        currentPage: this.clockFormData.pageNum,
        pageSize: this.clockFormData.pageSize,
        brandId: row.brandId,
        dateFormat: row.dateFormat,
        clockRole: row.clockRole,
        name: this.form.name,
        dateType: this.form.clockType
      }
      Api.getClockStatisticsDayList(params)
        .then(res => {
          this.clockTableData = res.data.pageInfo.list
          this.clockTotal = res.data.pageInfo.total
          this.dayWorkNums = res.data.workDays
          this.dayLoseCardNums = res.data.loseCardNums
          this.clockTableLoading = false
        })
    },
    // 监管员则剔除品牌名称一列，运维员则添加品牌名称一列
    dynamicColumns(clockRole) {
      if (clockRole !== 1) {
        // 如果 clockRole 不是 1，移除品牌名称列
        this.columns = this.columns.filter(col => col.label !== '品牌名称')
      } else {
        // 如果 clockRole 是 1，确保品牌名称列显示
        if (!this.columns.some(col => col.label === '品牌名称')) {
          this.columns.splice(3, 0, { label: '品牌名称', prop: 'brandId', width: '100' })
        }
      }
    },
    // 关闭弹框
    close() {
      this.visible = false
    },
    clockPageNoChange(page) {
      this.clockFormData.pageNum = page
      this.initData()
    },
    clockPageSizeChange(size) {
      this.clockFormData.pageSize = size
      this.initData()
    },
    onSearch() {
      this.clockFormData.pageNum = 1
      this.initData()
    },
    onReset() {
      this.form = {}
      this.initData()
    }
  }
}
</script>

<style scoped lang="less">
  .filters-clock {
    display: flex;
    margin-top: -10px;
    margin-left: 75%;
    .filters-clock-right {
      font-weight: bold;
      font-size: 16px;
      color: #44acff;
      cursor: pointer;
      position: absolute;
      right: 50px;
    }
  }
</style>
